import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Helpers
import { isPeripheralDevice } from 'src/helpers/addons/addon_device_helpers';
import { getDeviceIP } from '../core/webhook_devices_helpers';
import { deriveRoomName } from 'src/helpers/service_rooms_helpers';
import { real_id } from 'src/helpers/interface_helpers';
//Stores
import { devices_status } from 'src/stores/device-runtime/status';
//Types
import type { Device } from 'src/types/Device';

export const filterDevicesForActionList: any = (devices: Device[]) => {
	let filteredDevicesByRoom = {};
	const $format = get(format);
	const deviceStatuses = get(devices_status);
	devices.forEach((device: Device, i) => {
		const ip = getDeviceIP(device);

		if (!ip || (isPeripheralDevice(device?.type) && device.category !== 'relay')) return;

		const roomID = device.room_id;

		const deviceData = {
			...device,
			descriptiveText: !deviceStatuses[real_id(device.id)]?.online
				? $format('device_status_no_connection', {
						default: `Device is offline`,
					})
				: '',
			ip,
			roomID,
			roomName: deriveRoomName(roomID),
			disabled: false,
			selected: false,
		};

		if (filteredDevicesByRoom[roomID]) {
			filteredDevicesByRoom[roomID].cards = [...filteredDevicesByRoom[roomID].cards, deviceData];
		} else {
			filteredDevicesByRoom[roomID] = {
				cards: [deviceData],
				roomName: deriveRoomName(roomID),
				roomID: roomID,
			};
		}
	});

	return Object.values(filteredDevicesByRoom);
};
